module.exports = __webpack_public_path__ + "bd35a426f7b198f6bcb47eb2c4b46a7d.png";